import PropTypes from 'prop-types';
import { transformButton } from '@activebrands/core-web/libs/storyblok/utils/transform-buttons';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import ProductPromotion from 'components/content-components/Promotional/ProductPromotion';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformTag from '@activebrands/core-web/libs/storyblok/utils/transform-tag';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';

const ProductPromotionDataTransformerBlock = ({ content, slidesPerView, maxNumberOfProducts = 10, imageSettings }) => {
    const { _editable, anchorTag = [], button = {}, heading = [], paragraph, productSelection, layout, tag = [] } = content;

    const transformedButton = button?.[0] ? transformButton(button?.[0]) : {};
    const slicedProducts = productSelection?.[0]?.products?.slice(0, maxNumberOfProducts);

    return (
        <ProductPromotion
            button={transformedButton}
            columnSizes={[6, null, 3]}
            heading={transformHeading({ heading, defaultType: 'h2' })}
            id={transformAnchorTag({ anchorTag })}
            imageSettings={imageSettings}
            layout={layout}
            paragraph={transformParagraph({ paragraph })}
            products={slicedProducts}
            sbEditable={transformPreviewEditable(_editable)}
            slidesPerView={slidesPerView}
            tag={transformTag({ tag })}
        />
    );
};

ProductPromotionDataTransformerBlock.propTypes = {
    content: PropTypes.object.isRequired,
    imageSettings: PropTypes.object,
    maxNumberOfProducts: PropTypes.number,
    slidesPerView: PropTypes.array,
};

export default ProductPromotionDataTransformerBlock;
